export default __webpack_public_path__ + "static/google-32e37adab3f48c43ae86029ba4b8c4f8.svg";